import { COUNTRY, HrefLangListType, LANGUAGE } from "@type/index";
import { findStrIndex } from "@util/helpers";
import store from "@redux/store";

export const getHrefLangList = (endPath: string): HrefLangListType[] => {
  const { region, language } = store.getState().config;
  const _index = findStrIndex(endPath, "/", 2);
  const _path = endPath.slice(_index + 1);
  let hrefLang: HrefLangListType[] = [];
  switch (region) {
    case COUNTRY.CA:
      hrefLang = [
        {
          hrefLang: "en-ca",
          alternateHref: [COUNTRY.CA, LANGUAGE.EN, _path].join("/")
        },
        {
          hrefLang: "fr-ca",
          alternateHref: [COUNTRY.CA, LANGUAGE.FR, _path].join("/")
        }
      ];
      break;
    case COUNTRY.ID:
      hrefLang = [
        {
          hrefLang: "en-id",
          alternateHref: [COUNTRY.ID, LANGUAGE.EN, _path].join("/")
        },
        {
          hrefLang: "id-id",
          alternateHref: [COUNTRY.ID, LANGUAGE.ID, _path].join("/")
        }
      ];
      break;
    case COUNTRY.TH:
      hrefLang = [
        {
          hrefLang: "en-th",
          alternateHref: [COUNTRY.TH, LANGUAGE.EN, _path].join("/")
        },
        {
          hrefLang: "th-th",
          alternateHref: [COUNTRY.TH, LANGUAGE.TH, _path].join("/")
        }
      ];
      break;
    case COUNTRY.VN:
      hrefLang = [
        {
          hrefLang: "en-vn",
          alternateHref: [COUNTRY.VN, LANGUAGE.EN, _path].join("/")
        },
        {
          hrefLang: "vi-vn",
          alternateHref: [COUNTRY.VN, LANGUAGE.VI, _path].join("/")
        }
      ];
      break;
    default:
      hrefLang = [
        {
          hrefLang: `${language}-${region}`,
          alternateHref: [region, language, _path].join("/")
        }
      ];
      break;
  }
  return hrefLang;
};
